import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Breadcrumb } from 'models/Breadcrumb';
import { RootState } from 'store';
import { apiPut } from 'utils/request';

export const disableOnboarding = createAsyncThunk(
  'ui/disableOnboarding',
  async (_, { dispatch }) => {
    await apiPut(
      '/users/me',
      {
        walkthroughVisible: false,
      },
      {
        action: 'updateWalkthrough',
      },
    );
    const auth = JSON.parse(sessionStorage.getItem('auth')!);
    sessionStorage.setItem(
      'auth',
      JSON.stringify({
        ...auth,
        user: {
          ...auth.user,
          walkthroughVisible: false,
        },
      }),
    );
    dispatch(toggleShowOnboarding(false));
  },
);

interface State {
  showOnboarding: boolean;
  showAuthNews: boolean;
  inactiveScriptConfigs: string[];
  breadcrumbs: Breadcrumb[];
}

const auth = JSON.parse(sessionStorage.getItem('auth') || 'null');

const initialState: State = {
  showOnboarding: auth?.user.walkthroughVisible || false,
  showAuthNews: true,
  inactiveScriptConfigs: [],
  breadcrumbs: [],
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleShowOnboarding(state, action: PayloadAction<boolean>) {
      state.showOnboarding = action.payload;
    },
    toggleShowAuthNews(state, action: PayloadAction<boolean>) {
      state.showAuthNews = action.payload;
    },
    addInactiveScriptConfig(state, action: PayloadAction<string>) {
      if (!state.inactiveScriptConfigs.includes(action.payload)) {
        state.inactiveScriptConfigs.push(action.payload);
      }
    },
    removeInactiveScriptConfig(state, action: PayloadAction<string>) {
      state.inactiveScriptConfigs = state.inactiveScriptConfigs.filter(
        (config) => config !== action.payload,
      );
    },

    resetInactiveScriptConfigs(state) {
      state.inactiveScriptConfigs = [];
    },
    setBreadcrumbs(state, action: PayloadAction<Breadcrumb[]>) {
      state.breadcrumbs = action.payload;
    },
  },
});

export const selectShowOnboarding = (state: RootState) => state.ui.showOnboarding;
export const selectShowAuthNews = (state: RootState) => state.ui.showAuthNews;
export const selectInactiveScriptConfigs = (state: RootState) =>
  state.ui.inactiveScriptConfigs;
// export const selectShowOnboarding = (state: RootState) => false;
export const selectBreadcrumbs = (state: RootState) => state.ui.breadcrumbs;

export const {
  toggleShowOnboarding,
  toggleShowAuthNews,
  addInactiveScriptConfig,
  removeInactiveScriptConfig,
  resetInactiveScriptConfigs,
  setBreadcrumbs,
} = uiSlice.actions;
export const reducer = uiSlice.reducer;
